import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45b0927e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("正常")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 3 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"8px"} }, "上传", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_17 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_form_item_rest = _resolveComponent("a-form-item-rest")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_UploadComponent = _resolveComponent("UploadComponent")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "活动管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          onClick: _ctx.add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_input, {
            placeholder: "活动名称",
            value: _ctx.searches.title,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.title) = $event)),
            style: {"width":"200px"}
          }, null, 8, ["value"]),
          _createVNode(_component_a_select, {
            ref: "select",
            value: _ctx.searches.tag_id,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.tag_id) = $event)),
            style: {"width":"200px","margin-left":"10px"},
            placeholder: "请选择标签"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  key: index,
                  value: item.id
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.tag), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_a_select, {
            ref: "select",
            value: _ctx.searches.status,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.status) = $event)),
            style: {"width":"200px","margin-left":"10px"},
            placeholder: "请选择状态"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: 1 }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: 0 }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_a_button, {
            type: "primary",
            style: {"margin-left":"10px"},
            onClick: _ctx.onSearch
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            style: {"margin-left":"10px"},
            onClick: _ctx.onReset
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createVNode(_component_a_table, {
          style: {"margin-top":"10px"},
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'status')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(record.status == 0 ? '禁用' : '正常'), 1))
              : _createCommentVNode("", true),
            (column.key === 'content')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: record.content
                }, null, 8, _hoisted_7))
              : _createCommentVNode("", true),
            (column.key === 'tplOps')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(record.tplOps, (item, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    style: {"margin-right":"10px"}
                  }, _toDisplayString(item.label), 1))
                }), 128))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => (_ctx.getdetail(record)),
                    style: {"margin-left":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "操作该数据?",
                    onConfirm: ($event: any) => (_ctx.onStatus(record))
                  }, {
                    default: _withCtx(() => [
                      (record.status==1)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            size: "small",
                            style: {"margin":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (record.status==0)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            size: "small",
                            style: {"margin":"5px"}
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "删除该数据?",
                    onConfirm: ($event: any) => (_ctx.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[14] || (_cache[14] = ($event: any) => (_ctx.onSubmit('formRef'))),
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: _ctx.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "活动标识",
              name: "tag"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.tag,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.tag) = $event)),
                  placeholder: "请输入活动标识"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "活动标题",
              name: "title"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.title,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.title) = $event)),
                  placeholder: "请输入标题"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "活动内容",
              name: "content"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_EditorComponent, {
                      ref: "editorComponentRef",
                      "is-extra": true,
                      content: _ctx.formState.content,
                      extra: null
                    }, null, 8, ["content"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              ref: "image",
              label: "图片",
              name: "images"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  "file-list": _ctx.filelist,
                  "onUpdate:file-list": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filelist) = $event)),
                  headers: _ctx.uploadHeaders,
                  action: _ctx.uploadAction,
                  data: _ctx.uploadFormData,
                  "list-type": "picture-card",
                  onChange: _ctx.handleChange2,
                  remove: _ctx.remove2
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_plus_outlined),
                      _hoisted_14
                    ])
                  ]),
                  _: 1
                }, 8, ["file-list", "headers", "action", "data", "onChange", "remove"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "image",
              label: "视频",
              name: "videos"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item_rest, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_UploadComponent, {
                      "on-change": _ctx.onMediaChange,
                      "source-url": _ctx.formState.videos[0],
                      type: "video",
                      style: {"width":"100%"}
                    }, null, 8, ["on-change", "source-url"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.sort,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.sort) = $event)),
                  placeholder: "请输入排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "开始时间",
              name: "start_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.formState.start_time,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.start_time) = $event)),
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _ctx.dayjs('00:00:00', 'HH:mm:ss') },
                  style: {"width":"100%"}
                }, null, 8, ["value", "show-time"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "结束时间",
              name: "end_time"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_date_picker, {
                  value: _ctx.formState.end_time,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.end_time) = $event)),
                  format: "YYYY-MM-DD HH:mm:ss",
                  "show-time": { defaultValue: _ctx.dayjs('00:00:00', 'HH:mm:ss') },
                  style: {"width":"100%"}
                }, null, 8, ["value", "show-time"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "状态",
              name: "status"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formState.status,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "选项",
              name: "options"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.options,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formState.options) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择选项",
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.xuanxiangList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "模板",
              name: "template_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.template_id,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formState.template_id) = $event)),
                  style: {"width":"100%"},
                  placeholder: "请选择模板"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "标签",
              name: "tag_ids"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: _ctx.formState.tag_ids,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formState.tag_ids) = $event)),
                  style: {"width":"100%"},
                  mode: "multiple",
                  placeholder: "请选择标签"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tagList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.tag), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.visibleShow,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.visibleShow) = $event)),
      title: "活动详情",
      style: {"width":"50%"},
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          bordered: "",
          size: "middle"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "活动名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.title), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "活动标识" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.tag), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.sort), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.status==0?'禁用':'正常'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "开始时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.start_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "结束时间" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.detailData.end_time), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "图片" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.images, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_image, {
                    key: index,
                    src: item,
                    style: {"width":"100px","margin-left":"20px","height":"100px"}
                  }, null, 8, ["src"]))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "活动内容" }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  innerHTML: _ctx.detailData.content,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_17)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}